const apiClient = require('@/api/client.js')
import { ToastProgrammatic as Toast } from 'buefy'

export default {

  get(driver_id, callback){

    if (!driver_id){
      return callback(new Error('Invalid driver id'))
    }

    return apiClient.get('/employee', {id: driver_id}, callback);

  },

  inviteDriverViaPhone(phone_country, phone, callback){

    if (!phone_country){
      return callback(new Error('Invalid phone country'))
    }

    if (!phone){
      return callback(new Error('Invalid phone'))
    }

    let params = {
      phone,
      phone_country
    }

    return apiClient.post('/driver/invite', params, callback);
  },

  createDriver(params, callback){

    return apiClient.post('/employee', params, callback);

  },

  getMaskedDriverNumber(hash, callback) {
    return apiClient.post(`/job/${hash}/contact-driver`, null, callback);
  }

}



// WEBPACK FOOTER //
// ./src/components/driver/service.js